"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePagePropsRequestContext = exports.getRequestContextFromPageProps = exports.REQUEST_CONTEXT_PAGE_PROP = exports.syncDeviceAndLanguage = exports.isShallowEqual = exports.getRequestContextWeb = exports.getDeviceTypeWeb = exports.getPartnerWeb = exports.getLanguageWeb = exports.getBD4TravelWeb = exports.getB2BMarkupWeb = exports.getAgencyWeb = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
const libs_context_device_type_1 = require("@hotelplan/libs.context.device-type");
const libs_next_utils_1 = require("@hotelplan/libs.next-utils");
const libs_utils_1 = require("@hotelplan/libs.utils");
const fdr_lib_context_request_util_1 = require("@hotelplan/fdr.lib.context.request-util");
const fdr_lib_i18n_lang_page_props_1 = require("@hotelplan/fdr.lib.i18n.lang-page-props");
function getAgencyWeb() {
    return js_cookie_1.default.get(fdr_lib_context_request_util_1.AGENCY_KEY);
}
exports.getAgencyWeb = getAgencyWeb;
function getB2BMarkupWeb() {
    const b2bMarkup = js_cookie_1.default.get(fdr_lib_context_request_util_1.B2B_MARKUP_KEY);
    return b2bMarkup ? +b2bMarkup : undefined;
}
exports.getB2BMarkupWeb = getB2BMarkupWeb;
function getBD4TravelWeb() {
    return js_cookie_1.default.get(fdr_lib_context_request_util_1.BD4_USER_ID_KEY);
}
exports.getBD4TravelWeb = getBD4TravelWeb;
function getLanguageWeb() {
    return (0, libs_utils_1.getPageLanguage)(js_cookie_1.default.get(fdr_lib_context_request_util_1.LANGUAGE_COOKIE_KEY));
}
exports.getLanguageWeb = getLanguageWeb;
function getPartnerWeb() {
    return js_cookie_1.default.get(fdr_lib_context_request_util_1.PARTNER_KEY);
}
exports.getPartnerWeb = getPartnerWeb;
function getDeviceTypeWeb() {
    return (0, libs_context_device_type_1.mapDeviceTypeToServerDeviceType)(typeof window !== 'undefined'
        ? (0, libs_context_device_type_1.getDeviceTypeByScreenWidth)(window.innerWidth)
        : libs_context_device_type_1.DeviceType.Desktop);
}
exports.getDeviceTypeWeb = getDeviceTypeWeb;
function getRequestContextWeb(patch) {
    return (0, fdr_lib_context_request_util_1.compactHeaders)(Object.assign({ agency: getAgencyWeb(), b2bMarkup: getB2BMarkupWeb(), bd4TravelUserId: getBD4TravelWeb(), device: getDeviceTypeWeb(), language: getLanguageWeb(), partner: getPartnerWeb() }, patch));
}
exports.getRequestContextWeb = getRequestContextWeb;
const isShallowEqual = (obj1, obj2) => {
    if (obj1 === obj2)
        return true;
    if (Object.keys(obj1).length !== Object.keys(obj2).length)
        return false;
    return Object.keys(obj1).every(key => obj1[key] === obj2[key]);
};
exports.isShallowEqual = isShallowEqual;
const syncDeviceAndLanguage = (ctx, lang, mobile) => {
    const device = mobile ? fdr_lib_context_request_util_1.EDeviceType.Mobile : fdr_lib_context_request_util_1.EDeviceType.Desktop;
    const language = (0, fdr_lib_i18n_lang_page_props_1.getPageLang)(lang || ctx.language || undefined);
    if (device !== ctx.device || language !== ctx.language) {
        return Object.assign(Object.assign({}, ctx), { device, language });
    }
    return ctx;
};
exports.syncDeviceAndLanguage = syncDeviceAndLanguage;
exports.REQUEST_CONTEXT_PAGE_PROP = '_rct';
const requestContextPropGetter = (0, libs_next_utils_1.createPagePropGetter)(exports.REQUEST_CONTEXT_PAGE_PROP);
function getRequestContextFromPageProps(pageProps) {
    return requestContextPropGetter(pageProps);
}
exports.getRequestContextFromPageProps = getRequestContextFromPageProps;
function usePagePropsRequestContext(pageProps) {
    return getRequestContextFromPageProps(pageProps) || getRequestContextWeb();
}
exports.usePagePropsRequestContext = usePagePropsRequestContext;
//# sourceMappingURL=request-context.utils.js.map